/**
 * @generated SignedSource<<81d38caf34f660e0f6e3842d6942a6c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphCalendar_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly description: string;
  readonly entity: {
    readonly createdBy?: {
      readonly thirdPartyUser: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly eventEndTime?: string | null | undefined;
    readonly eventStartTime?: string | null | undefined;
    readonly recurringEventId?: string | null | undefined;
    readonly videoMeetingUrl?: string | null | undefined;
  } | null | undefined;
  readonly excerpt: string | null | undefined;
  readonly id: string;
  readonly integrationId: string | null | undefined;
  readonly linkedEntities: ReadonlyArray<{
    readonly entity: {
      readonly eventEndTime?: string | null | undefined;
      readonly eventStartTime?: string | null | undefined;
      readonly videoMeetingUrl?: string | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly title: string;
    readonly url: string;
  }> | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly permissionLevel: string | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphCalendar_AtlassianSearchPage";
};
export type searchGraphCalendar_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphCalendar_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphCalendar_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "description"
},
v4 = {
  "kind": "ScalarField",
  "name": "integrationId"
},
v5 = {
  "kind": "ScalarField",
  "name": "eventEndTime"
},
v6 = {
  "kind": "ScalarField",
  "name": "eventStartTime"
},
v7 = {
  "kind": "ScalarField",
  "name": "videoMeetingUrl"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphCalendar_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    (v4/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": [
                {
                  "concreteType": "ThirdPartyUser",
                  "kind": "LinkedField",
                  "name": "thirdPartyUser",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "name"
                    }
                  ]
                }
              ]
            },
            (v5/*: any*/),
            (v6/*: any*/),
            {
              "kind": "ScalarField",
              "name": "recurringEventId"
            },
            (v7/*: any*/)
          ],
          "type": "ExternalCalendarEvent"
        }
      ]
    },
    {
      "concreteType": "SearchResultGraphDocument",
      "kind": "LinkedField",
      "name": "linkedEntities",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v6/*: any*/),
                (v5/*: any*/),
                (v7/*: any*/)
              ],
              "type": "ExternalCalendarEvent"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "lastModifiedDate"
        },
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "fe83f0e60cf642e25009d9ac9051f446";

export default node;
